// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ClubJoin--avatar--JxicB"};